/* src/app/components/review/validation/doc-review-validation-message/doc-review-validation-message.component.scss */
.content {
  background: rgba(57, 73, 171, 0.08);
  padding: 4px;
  margin-top: 6px;
  border-radius: 16px;
}
:host-context(.dark-theme) .content {
  background: rgba(255, 193, 7, 0.06);
}
.list-item {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  margin-bottom: 8px;
  margin-top: 8px;
  padding: 2px;
  justify-content: space-around;
  align-items: flex-start;
  flex-wrap: nowrap;
}
.alert-note {
  font-size: 16px;
  margin-right: 10px;
}
/*# sourceMappingURL=doc-review-validation-message.component.css.map */
